import { OptionType } from '@evinced-private/ui-common';

import { UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';

import {
	BUSINESS_UNIT_NORMALIZED_KEY,
	ENVIRONMENT_NORMALIZED_KEY,
	NO_OPTION_VALUE_SUFFIX
} from '../../consts/FilterNoOptionConstants';

const normalize = (value: string): string => value.trim().toLowerCase();

const parseLabelParts = (rawValue: string): { key: string; value: string } | null => {
	const colonIndex = rawValue.indexOf(':');
	if (colonIndex <= 0) {
		return null;
	}

	const key = rawValue.substring(0, colonIndex).trim();
	const value = rawValue.substring(colonIndex + 1).trim();

	if (!key || !value) {
		return null;
	}

	return { key, value };
};

const getNoOptionSelection = (
	optionValue: unknown
): { key: string; normalizedKey: string } | null => {
	if (typeof optionValue !== 'string') {
		return null;
	}

	const parts = parseLabelParts(optionValue);
	if (!parts) {
		return null;
	}

	if (normalize(parts.value) !== normalize(NO_OPTION_VALUE_SUFFIX)) {
		return null;
	}

	return {
		key: parts.key,
		normalizedKey: normalize(parts.key)
	};
};

export const separateNoOptionLabels = (
	labels?: OptionType[]
): {
	sanitizedLabels: OptionType[];
	environmentNeTupleKey?: string[];
	unitIdNeTupleKey?: string[];
	environmentsNoOption?: boolean;
} => {
	if (!labels?.length) {
		return {
			sanitizedLabels: []
		};
	}

	const environmentNeTupleKey: string[] = [];
	const unitIdNeTupleKey: string[] = [];
	let environmentsNoOption = false;

	const sanitizedLabels = labels.filter((option) => {
		const selection = getNoOptionSelection(option.value);
		if (selection) {
			const normKey = selection.normalizedKey;
			if (normKey === ENVIRONMENT_NORMALIZED_KEY) {
				environmentsNoOption = true;
				if (!environmentNeTupleKey.includes(selection.key)) {
					environmentNeTupleKey.push(selection.key);
				}
				return false;
			}
			// Handle business unit no option
			if (normKey === BUSINESS_UNIT_NORMALIZED_KEY) {
				// Use the proper casing for unitId
				const keyToAdd = UNIT_ID_LABEL_KEY;
				if (!unitIdNeTupleKey.includes(keyToAdd)) {
					unitIdNeTupleKey.push(keyToAdd);
				}
				return false;
			}
			return false;
		}
		return true;
	});

	const resultEnvironmentNeTupleKey =
		environmentNeTupleKey.length > 0 ? environmentNeTupleKey : undefined;
	const resultUnitIdNeTupleKey = unitIdNeTupleKey.length > 0 ? unitIdNeTupleKey : undefined;

	return {
		sanitizedLabels,
		...(resultEnvironmentNeTupleKey ? { environmentNeTupleKey: resultEnvironmentNeTupleKey } : {}),
		...(resultUnitIdNeTupleKey ? { unitIdNeTupleKey: resultUnitIdNeTupleKey } : {}),
		...(environmentsNoOption ? { environmentsNoOption } : {})
	};
};
